import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { SitesFilter } from "gatsby-theme-gba"

const SiteFilterEditable = ({ blok }) => {
  let industriesValue = {
    agrochemical: blok.agrochemical,
    construction: blok.construction,
    cosmetics: blok.cosmetics,
    environment: blok.environment,
    food: blok.food,
    medical: blok.medical,
    pharma: blok.pharma,
    veterinary: blok.veterinary,
    wasser: blok.wasser,
  }
  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <SitesFilter
        heading={blok.heading}
        analysesText={blok.analysesText}
        countryText={blok.countryText}
        industryText={blok.industryText}
        serviceText={blok.serviceText}
        currentLanguage={blok.currentLanguage}
        moreText={blok.moreText}
        lessText={blok.lessText}
        plzOrtPlaceholder={blok.plzOrtPlaceholder}
        plzOrtText={blok.plzOrtText}
        plzOrtNotice={blok.plzOrtNotice}
        companyText={blok.CompanyText}
        industriesNames={industriesValue}
      ></SitesFilter>
    </div>
  )
}

export default SiteFilterEditable
